import { ThemeUIStyleObject } from 'theme-ui'

export const styles: Record<string, ThemeUIStyleObject> = {
  topContainer: {
    borderRadius: '10px',
    width: '100%',
    margin: '20px 0px 10px 0px',
    background: 'white3',
    padding: '30px 0',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}
